import React, { Component } from 'react'

import BaseErrorComponent from 'shared/components/errors/BaseErrorComponent'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)

    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    // Sentry loaded globally in <head> tag
    if (typeof Sentry !== 'undefined') {
      // eslint-disable-next-line
      Sentry.withScope(scope => {
        for (const key in info) {
          scope.setExtra(key, info[key])
        }
        Sentry.captureException(error)
      })
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
          <BaseErrorComponent
            isEditor={this.props.isEditor}
            errorCode={'500'}
            errorMessage={'Something went wrong, try refreshing the page.'}
          />
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
